import { parsePhoneNumber, isValidPhoneNumber } from "libphonenumber-js"

export const BY_PHONE_PLACEHOLDER = "+375 (29) 123-45-67"

// HTML pattern for BY numbers: +375 (XX) XXX-XX-XX
export const BY_PHONE_PATTERN = String.raw`^\+375\s?\(\d{2}\)\s?\d{3}-\d{2}-\d{2}$`

// Generic international pattern: +<digits, spaces, (), -> length-limited
export const INTL_PHONE_PATTERN = String.raw`^\+[0-9 ()-]{6,20}$`
// Combined: BY mask OR generic international
export const PHONE_PATTERN = String.raw`^(?:\+375\s?\(\d{2}\)\s?\d{3}-\d{2}-\d{2}|\+[0-9 ()-]{6,20})$`

const digitsOnly = (s: string) => s.replace(/\D+/g, "")

// Formats input into +375 (XX) XXX-XX-XX, tolerating partial typing
export const formatBYPhone = (raw: string): string => {
  if (!raw) return ""
  const d = digitsOnly(raw)
  let local = d
  if (d.startsWith("375")) local = d.slice(3)
  // Limit to 9 local digits
  const nine = local.slice(0, 9)
  const a = nine.slice(0, 2) // operator
  const b = nine.slice(2, 5) // next 3
  const c = nine.slice(5, 7) // next 2
  const e = nine.slice(7, 9) // last 2

  let out = "+375"
  if (a.length) out += ` (${a}`
  if (a.length === 2) out += ")"
  if (b.length) out += (a.length === 2 ? " " : ") ") + b // close ) if user typed fast
  if (c.length) out += `-${c}`
  if (e.length) out += `-${e}`

  return out
}

export const isValidBYPhone = (val: string) => {
  if (!val) return false
  try {
    return new RegExp(BY_PHONE_PATTERN).test(val)
  } catch {
    return false
  }
}

// Auto formatter: if it's BY (+375) — apply BY mask, else keep user input cleaned
export const formatPhoneAuto = (raw: string): string => {
  if (!raw) return ""
  const trimmed = raw.replace(/\s+/g, " ")
  if (trimmed.startsWith("+375")) {
    return formatBYPhone(trimmed)
  }
  // Keep only allowed characters, do not force leading +
  return trimmed.replace(/[^+0-9()\s\-]/g, "")
}

/**
 * Валидация международного номера телефона с использованием libphonenumber-js
 * Проверяет, является ли номер корректным для любой страны
 */
export const validateInternationalPhone = (
  phoneNumber: string,
): { isValid: boolean; country?: string } => {
  if (!phoneNumber || phoneNumber.trim().length === 0) {
    return { isValid: false }
  }

  try {
    // Проверяем валидность номера для любой страны
    const isValid = isValidPhoneNumber(phoneNumber)

    if (isValid) {
      // Если номер валиден, пытаемся определить страну
      const parsed = parsePhoneNumber(phoneNumber)
      return {
        isValid: true,
        country: parsed.country,
      }
    }

    return { isValid: false }
  } catch {
    // Если произошла ошибка парсинга, номер невалиден
    return { isValid: false }
  }
}
